module.exports = __webpack_public_path__ + "img/optaline.f3e1d9c3.png";